import { render } from "./SettingDots.vue?vue&type=template&id=31b27203&scoped=true"
const script = {}

import "./SettingDots.vue?vue&type=style&index=0&id=31b27203&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b27203"]])

export default __exports__